const classLists = state => state.classLists;
const subjectLists = state => state.subjectLists;
const memberLists = state => state.memberLists;
const documentLists = state => state.documentLists;
const events = state => state.events;
const getParamListSchool = state => state.getParamListSchool;
const getCourseDetail = state => state.getCourseDetail;
const getClassListMember = state => state.getClassListMember;
const getListLesonPlan = state => state.getListLesonPlan;
const getParamDoccument = state => state.getParamDoccument;
const getListClassDoccument = state => state.getListClassDoccument;
const getListEvent = state => state.getListEvent;
const getDetailEvent = state => state.getDetailEvent;
const getListClassPostion = state => state.getListClassPostion;

export default {
    classLists,
    subjectLists,
    memberLists,
    documentLists,
    events,
    getParamListSchool,
    getCourseDetail,
    getClassListMember,
    getListLesonPlan,
    getParamDoccument,
    getListClassDoccument,
    getListEvent,
    getDetailEvent,
    getListClassPostion
};